import {
  USERS_AUTHEN,
  USERS_LOGIN,
  USERS_LOGIN_VALIDATE,
  USERS_LOGIN_VERIFY,
  USERS_PROFILE,
  USERS_SERVICE_INFO
} from 'client/api';
import { client } from 'client/request';
import { IParams, some } from 'types';
import { isEmpty } from 'lodash';
import queryString from 'query-string';

const getUserProfile = async () => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await client.get(USERS_PROFILE, {});

    return res.data;
  } catch (err) {
    throw err;
  }
};

const login = (params) => {
  return new Promise((resolve, reject) => {
    client
      .post(USERS_LOGIN, params)
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const loginValidate = (params) => {
  return new Promise((resolve, reject) => {
    client
      .post(USERS_LOGIN_VALIDATE, params)
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const verifyLogin = (params) => {
  return new Promise((resolve, reject) => {
    client
      .post(USERS_LOGIN_VERIFY, params)
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getUserAuthen = async ({ params, signal }: IParams) => {
  const url = isEmpty(params)
    ? USERS_AUTHEN
    : `${USERS_AUTHEN}?${queryString.stringify(params ?? {})}`;
  const res: some = await client.get(url, { signal });

  return res.data;
};

const getServiceInfo = (params) => {
  return new Promise((resolve, reject) => {
    client
      .post(USERS_SERVICE_INFO, params)
      .then((res) => {
        const { data } = res;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default {
  login,
  getUserProfile,
  loginValidate,
  verifyLogin,
  getServiceInfo,
  getUserAuthen
};
